export const uploadImage = process.env.REACT_APP_BASE_URL + 'user/upload/upload-image'


export const signInVenue = 'venue/auth/sign-in'
export const createVenueOwner = 'venue/auth/create-venue-owner'
export const sendOtpEmail = "venue/auth/email-send-otp"
export const verifyOtp = "venue/auth/email-verify-otp"

export const getVenueBased = "venue/venue/get-venue-based-filter"
export const saveVenueDocument = "venue/venue/save-venue-owner-document"